const OLD_DOMAIN_SUFFIX = ".nh360online.com";
const NEW_DOMAIN_SUFFIX = ".northhighland.ai";

/**
 * Old hosts whose new name is not a straight suffix swap. Anything else on
 * the old domain keeps its subdomain and only changes the suffix.
 */
const MOVED_HOSTS: Record<string, string> = {
  "aims.nh360online.com": "aims.northhighland.ai",
  "aims-stage.nh360online.com": "aims-stage.northhighland.ai",
  "projectiq.nh360online.com": "projectiq.northhighland.ai",
  "staging-projectiq.nh360online.com": "projectiq-stage.northhighland.ai",
};

/**
 * Returns the same page on the new domain when `location` is on the old
 * nh360online.com domain, keeping path, query and hash so deep links still
 * land where the user meant to go. Returns null when no move is needed.
 */
export const getMovedUrl = (
  location: Pick<
    Location,
    "protocol" | "hostname" | "pathname" | "search" | "hash"
  >,
): string | null => {
  const hostname = location.hostname.toLowerCase();
  if (!hostname.endsWith(OLD_DOMAIN_SUFFIX)) {
    return null;
  }

  const newHostname =
    MOVED_HOSTS[hostname] ??
    `${hostname.slice(0, -OLD_DOMAIN_SUFFIX.length)}${NEW_DOMAIN_SUFFIX}`;

  return `https://${newHostname}${location.pathname}${location.search}${location.hash}`;
};
